<script setup>
import { ref, toRefs, computed, useAttrs, mergeProps  } from 'vue';
import { v4 as uuidv4 } from 'uuid';

defineOptions({
    inheritAttrs: false,
});

const props = defineProps({
    id: {
        type: String,
        required: false,
        default: () => "radio-button--" + uuidv4(),
    },
    modelValue: {
        type: [Number, String],
        required: false,
        default: '',
    },
    value: {
        type: [Number, String],
        required: false,
        default: '',
    },
    inline: {
        type: Boolean,
        required: false,
        default: false,
    },
});
const emit = defineEmits(['update:modelValue']);

const attrs = useAttrs();

const { modelValue, value } = toRefs(props);

const initialType = ref(typeof props.modelValue);

const checked = computed(() => modelValue.value === value.value);

const inputListeners = computed(() => {
    return {
        change: (event) => {
            const val = event.target.value;
            emit('update:modelValue', initialType.value === 'number' ? parseInt(val, 10) : val);
        },
    };
});

const outerAttrs = computed(() => mergeProps(
    { class: attrs.class },
    { class: { 'radio': true, 'radio-inline': props.inline } },
));
</script>

<template>
    <div v-bind="outerAttrs">
        <input
            v-bind="{ ...$attrs, class: undefined }"
            v-on="inputListeners"
            type="radio"
            :checked="checked"
            :id="id"
            :value="value"
        >
        <label :for="id">
            <slot />
        </label>
    </div>
</template>
